import * as S from './style'

export const Sign = () => {
  return (
    <S.BannerWrapper>
      <S.BannerContent>
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
        <S.BannerText>
          Seus ativos estão pedindo socorro!
        </S.BannerText>
        ●
      </S.BannerContent>
    </S.BannerWrapper>

  )
}
